import styled from '@emotion/styled'

export const SList = styled.ul`
  list-style: none;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  padding: 0;
  margin: 0;
  flex-grow: 1;

  & > *:not(:last-child) {
    margin-bottom: 5px;
  }
`
